module.exports = __webpack_public_path__ + "img/mesaj.27393f20.png";